import React from 'react';
import DsModal from '../../DsModal';
import { CardListSkeleton } from '../../ContentSkeletons';

export default function MemberListModalLayout({
  onClose,
  dialogClassName = 'member-modal__dialog',
  dialogProps = {},
  titleClassName = 'member-modal__title',
  titleIconClassName = 'fa-solid fa-people-group',
  titleText = 'メンバーリスト',
  bodyClassName = 'member-modal__body',
  loading = false,
  loadingClassName = 'member-modal__loading',
  loadingInsideBody = false,
  children,
  profileNode = null,
  profilePlacement = 'outside',
}) {
  const titleNode = (
    <span className={titleClassName}>
      <i className={titleIconClassName} aria-hidden="true" /> {titleText}
    </span>
  );

  return (
    <>
      <DsModal
        open
        onClose={onClose}
        title={titleNode}
        className={dialogClassName}
        {...dialogProps}
      >
        {loading ? (
          loadingInsideBody ? (
            <div className={bodyClassName}>
              <CardListSkeleton rows={5} className={loadingClassName} />
            </div>
          ) : (
            <CardListSkeleton rows={5} className={loadingClassName} />
          )
        ) : (
          <div className={bodyClassName}>{children}</div>
        )}
        {profilePlacement === 'inside' ? profileNode : null}
      </DsModal>
      {profilePlacement !== 'inside' ? profileNode : null}
    </>
  );
}
